import { Box, Typography } from "@mui/joy";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { capitalizeText } from "../../../lib/utils";
import {
  IDettaglio,
  ILotto,
  IQualita,
  IStatoLavorazione,
} from "../../../models";
import { IFilterOption } from "../../../models/utlis";
import SelectLottoFilterV2 from "./SelectLottoFiltersV2";
import SelectLottoGrid from "./SelectLottoGrid";
import { useTranslation } from "react-i18next";

interface ISelectLottoProps {
  dettagli: IDettaglio[];
  materialeSelected: IQualita | null;
  lavorazioni: IStatoLavorazione[];
  spessoriDisponibili: number[];
  filters: IFilterOption[];
  onSetFilters: (filters: IFilterOption[]) => void;
  onBack: () => void;
}

export default function SelectLottoV2({
  dettagli,
  materialeSelected,
  lavorazioni,
  spessoriDisponibili,
  filters,
  onSetFilters,
}: ISelectLottoProps) {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const onView = (id: number) => {
    navigate(`${id}`);
  };
  const backToMaterials = () => {
    window.parent?.postMessage({ action: "goBack" }, "*");
  };
  const lottiToDisplay = useMemo(() => {
    const _lotti: ILotto[] = [];
    dettagli.forEach((dettaglio) => {
      const lotto = dettaglio.lotto;
      if (lotto) {
        const existingLotto = _lotti.find((l) => l.id === lotto.id);
        if (!existingLotto) {
          lotto.dettagli = [dettaglio];
          _lotti.push(lotto);
        } else {
          existingLotto.dettagli?.push(dettaglio);
        }
      }
    });
    return _lotti;
  }, [dettagli]);
  const materialSelectedNome = useMemo(
    () =>
      i18n.language === "en" && materialeSelected?.nomeEn
        ? materialeSelected.nomeEn
        : materialeSelected?.nome ?? "",
    [materialeSelected, i18n]
  );
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          px: "20px",
          height: 64,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#36363d",
          "@media screen and (min-width: 1024px)": { px: "50px" },
        }}
      >
        <Box>
          <Typography level="h2">
            {capitalizeText(materialSelectedNome)}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          px: "20px",
          display: "flex",
          alignItems: "flex-start",
          "@media screen and (min-width: 1024px)": { px: "50px" },
        }}
      >
        <Typography
          level="body-md"
          onClick={backToMaterials}
          sx={{
            fontSize: "13px",
            whiteSpace: "nowrap",
            py: 2,
            cursor: "pointer",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          &lt; {t("Back")}
        </Typography>
        <SelectLottoFilterV2
          spessoriDisponibili={spessoriDisponibili}
          lavorazioni={lavorazioni}
          filters={filters}
          onSetFilters={onSetFilters}
        ></SelectLottoFilterV2>
      </Box>
      <Box sx={{ flex: 1, position: "relative" }}>
        <SelectLottoGrid lotti={lottiToDisplay} onView={onView} />
      </Box>
    </Box>
  );
}
